import React from 'react';
import { LINEAS } from '../channels';

/**
 * El menú lateral de configuración, agrupado por línea de negocio.
 *
 * Antes eran tres botones con el mismo markup copiado tres veces; añadir un
 * canal obligaba a copiarlo otra vez. Aquí la lista sale de `channels.js`.
 */
const SettingsNav = ({ activo, onSelect }) => (
  <nav className='bg-white rounded-lg border border-slate-200 overflow-hidden'>
    <div className='px-4 py-3 border-b border-slate-200 bg-slate-50'>
      <h3 className='text-sm font-medium text-slate-900'>Configuración</h3>
    </div>

    {LINEAS.map(linea => (
      <div key={linea.id} className='py-2 border-b border-slate-100 last:border-b-0'>
        <h4 className='px-4 pb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400'>
          {linea.nombre}
        </h4>

        {linea.canales.map(canal =>
          canal.pendiente ? (
            // Se enseña, pero no se puede pulsar: es el hueco de lo que falta,
            // no un botón roto.
            <div
              key={canal.id}
              className='px-4 py-2 text-sm text-slate-400 flex items-baseline justify-between gap-2'
            >
              <span>
                {canal.nombre}
                {canal.proveedor && <span className='text-slate-300'> · {canal.proveedor}</span>}
              </span>
              <span className='text-[10px] uppercase tracking-wide text-slate-300'>pendiente</span>
            </div>
          ) : (
            <button
              key={canal.id}
              type='button'
              onClick={e => {
                onSelect(canal.id);
                e.target.blur();
              }}
              className={`w-full text-left px-4 py-2 text-sm font-medium transition-colors outline-none focus:outline-none ${
                activo === canal.id
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                  : 'text-slate-700 hover:bg-slate-50'
              }`}
            >
              {canal.nombre}
              <span
                className={`font-normal ${activo === canal.id ? 'text-blue-400' : 'text-slate-400'}`}
              >
                {' '}
                · {canal.proveedor}
              </span>
            </button>
          )
        )}
      </div>
    ))}
  </nav>
);

export default SettingsNav;
